const BAD = ["mierda","cabron","puto","pendejo","idiota","stupid","fuck","shit","bitch","asshole","bastard","merda","puta"];
export function filterProfanity(text: string): string {
  let out = text;
  for (const w of BAD) {
    const re = new RegExp(`\\b${w}\\w*`, "gi");
    out = out.replace(re, (m) => "*".repeat(m.length));
  }
  return out;
}
export function looksAbusive(text: string): boolean {
  const t = text.toLowerCase();
  return BAD.some((w) => t.includes(w));
}
